<p-dialog header="Preview Data List" [(visible)]="displayPreviewDataList" (onHide)="onPreviewCancelClick()" [modal]="true" [closable]="false"
    [style]="{width: '55vw'}">
    <div class="card">
        <p-table [value]="previewDataList" [columns]="previewColumnList" responsiveLayout="scroll">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns">
                        <th>
                            {{col.header}}
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        <ng-container [ngSwitch]="col?.dataType">
                            <ng-container *ngSwitchCase="'date'">
                                {{ rowData[col.field] | date:'MM/dd/yyyy' }}
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ rowData[col.field] }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="summary" *ngIf="previewDataList?.length > 0">
                <tr>
                    <td colspan="18">Showing top 5 results of {{previewDataList?.length ?? 0}} based on rules.</td>
                </tr>
            </ng-template> -->
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="18">{{noData}}</td>
                </tr>
            </ng-template>
        </p-table>
        <div *ngIf="previewDataList?.length > 0" style="margin-top: 8px;" colspan="18">
            *Showing top 5 results based on added rules.
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="onPreviewCancelClick()" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>
